/*
 * @Description: 页面描述
 * @Author: MR.小涛
 * @Date: 2019-01-19 11:30:24
 * @LastEditors: MR.小涛
 * @LastEditTime: 2019-09-22 12:02:07
 */
'use strict'
import axios from 'axios'
// import qs from 'qs'
import { Loading, Message } from 'element-ui'
import store from '@/store'
import router from '../../router'
import { commonParams } from '../js/config'
// 让axios  支持cookie
axios.defaults.withCredentials = false
// if (process.env.NODE_ENV === 'production') {
//   window.baseUrl = window.base.ApiUrl
// } else {
//   window.baseUrl = process.env.API_ROOT
// }
window.baseUrl = process.env.API_ROOT
const basePath = window.baseUrl
axios.defaults.baseURL = window.baseUrl
let loadinginstace = null
// 请求拦截信息  config  代表当前的配置项
axios.interceptors.request.use(config => {
  // 发送请求之前做一些处理  我这里加了loading  你们也可以做其他的操作
  // 调用element-ui 的 loading
  if (config.showLoading) {
    loadinginstace = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  return config
}, err => {
  // 当请求异常时做一些处理
  return Promise.reject(err)
})
axios.interceptors.response.use(response => {
  // 返回响应时做一些处理
  // 我在数据返回的时候 关闭了 loading
  loadinginstace.close()
  return response
}, err => {
  // 当响应异常时做一些处理
  // 我在数据返回的时候 关闭了 loading
  loadinginstace.close()
  return Promise.resolve(err.response)
})
// 判断http状态码是否正常 请求正常则返回响应 请求异常则返回错误，最后返回结果给checkCode()。
const checkStatus = (response) => {
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response // 这里我只返回了   接口返回的请求信息    如果用到其他的  可以直接返回   return  response
  }
  return response
}
// 处理后台返回的状态 以及后端返回的异常
const checkCode = (res) => {

  switch (res.status) {
    case 200:
      if (res.config.responseType === 'blob') {
      }else{
        if (!res.data.success) {
          if(res.data.errorCode === '400003'){
            store.dispatch('loginAction', false)
            store.dispatch('setToken', '')
            Message({
              title: '提示',
              type: 'error',
              duration: 1200,
              message: res.data.errorMsg,
              onClose(){
                router.replace('/')
              }
            })
          }else{
            Message({
              title: '提示',
              type: 'error',
              duration: 1200,
              message: res.data.errorMsg
            })
          }
        }
      }        
      break
    case 201:
      Message({
        title: '提示',
        type: 'error',
        duration: 1200,
        message: res.data.errorMsg
      })
      break
    case 401:
      store.dispatch('loginAction', false)
      store.dispatch('setToken', '')
      Message({
        title: '提示',
        type: 'error',
        duration: 1200,
        message: res.data.errorMsg,
        onClose(){
          router.replace('/')
        }
      })
      break
    case 403:
      Message({
        title: '提示',
        type: 'error',
        duration: 1200,
        message: res.data.errorMsg
      })
      break
    case 404:
      Message({
        title: '提示',
        type: 'error',
        duration: 1200,
        message: res.data.errorMsg
      })
  }
  if (res.config.responseType === 'blob') {
    return res
  } else {
    return res.data
  }
}
export function getBasePath () {
  return basePath
}
export default {
  // 封装post方法
  /**
     *
     * @param {请求路径} url
     * @param {请求的参数} data
     */
  // axios.defaults.headers.common['Authorization'] = store.state.token
  post (url, data, responseType = null, showLoading = true) {
    return axios({
      showLoading: showLoading,
      method: 'post',
      // baseURL: 'http://localhost:8886', // baseURL  默认请求的前置路径会自动拼接 Url
      url, //   url  Es6 写法  等同于  url:url
      data: Object.assign({}, commonParams, data), // 这里使用了  qs模块来转换Data 因为在Post请求的时候  默认application/json (可根据后台定义)
      timeout: 1000 * 60 * 3,
      responseType: responseType,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': store.state.token,
        'token': store.state.token
      }
    }).then(response => checkStatus(response)).then(res => checkCode(res))
  },
  /**
     *
     * @param {请求路径} url
     * @param {请求的参数} data
     */
  get (url, params, responseType = null) {
    return axios({
      method: 'get',
      // baseURL: 'http://localhost:8886', // baseURL  默认请求的前置路径会自动拼接 Url
      url, //   url  Es6 写法  等同于  url:url
      params: Object.assign({}, commonParams, params),
      timeout: 1000 * 60 * 3, // 请求超时返回网络异常
      headers: { // 设置响应头信息
        'X-Requested-With': 'XMLHttpRequest',
        'Authorization': store.state.token,
        'token': store.state.token
      }
    }).then(response => checkStatus(response)).then(res => checkCode(res)) //  成功后的回调
  },

  uploadImg(url,params){
    console.log('上传图片')
    return axios({
      method: 'POST',
      // baseURL: 'http://localhost:8886', // baseURL  默认请求的前置路径会自动拼接 Url
      url, //   url  Es6 写法  等同于  url:url
      timeout: 1000 * 60 * 3, // 请求超时返回网络异常
      headers: { // 设置响应头信息
        'X-Requested-With': 'XMLHttpRequest',
        // 'Content-Type': 'multipart/form-data',
        'Authorization': store.state.token,
        'token': store.state.token
      }
    }).then(response => checkStatus(response)).then(res => checkCode(res)) //  成功后的回调
  }
}

/**
 * Author:Mr.xiaotao
 * Describe: 基于Axios  二次封装拦截器
 * QQ&WeChat:978252877
 */

/**
 * 用法：
 * main.js :
 * import http from './plugins/http'
 * Vue.prototype.$http = http
 * 举个栗子：
 * App.vue:
 * this.$http('/user/login',{name:xiaotao}).then(res=>{
 *     console.log(res)
 * })
 *
 */



// WEBPACK FOOTER //
// ./src/common/js/http.js